import {FjdIcon, FjdStack} from "@efast/fjd-react-components";
import {Certificate} from "../../model/Certificate";
import txt from "./../../content.json";
import "./CertificateAuthority.css";
import React from "react";

export interface CertificateAuthorityProps {
    certificate?: Certificate;
}

function CertificateAuthority({certificate}: CertificateAuthorityProps) {
    if (!certificate || !certificate.authority) {
        return null;
    }

    return (
        <FjdStack className="certificate-authority">
            <FjdIcon glyph="home" size="xxl"></FjdIcon>
            <FjdStack>
                <strong>{txt.certificateAuthority.issuedBy}</strong>
                <br/>
                <span>{certificate.authority.split(/\r?\n/).map(l => <>{l}<br/></>)}</span>
                {certificate.submittedOn && (
                    <>
                        <br/>
                        <strong>{txt.certificateAuthority.submittedOn}</strong>
                        <span>{certificate.submittedOn}</span>
                    </>
                )}
            </FjdStack>
        </FjdStack>
    );
}

export default CertificateAuthority;
